import React, { useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import left_arrow from "../../assets/images/icon/arrow-btn.svg";

import DOMPurify from "dompurify";

const RangeTableComponent = props => {
  const { t } = useTranslation();
  let data = props?.data;

  if (props?.type === "dashboard") {
    data = data?.slice(0, 5);
  }
  const [tableSwitch, setTableSwitch] = useState(false);

const preprocessData = data => {
  return data.map(job => {
    const minSalary = job.min_salary
      ? job.min_salary.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      : "₹0";

    const maxSalary = job.max_salary
      ? job.max_salary.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      : "₹0";

    return {
      ...job,
      min_ctc_offered: job.min_ctc_offered || 0,
      max_ctc_offered: job.max_ctc_offered || 0,
      avg_ctc_offered: job.avg_ctc_offered || 0,
      title_with_salary: `${
        job.title
      }<br><span class="salary-range" style="color: #888; font-weight: lighter;">
        ${t("Dashboard.Budget")} (${minSalary} - ${maxSalary})
      </span>`,
    };
  });
};


  const preprocessedData = preprocessData(data);

  const columns = [
    {
      dataField: "title_with_salary",
      text: t(`Dashboard.Job Title`),
      classes: "job-title jobtitles text-left",
      headerClasses: "text-left jobtitles Shortlisted-fto-fs",
      formatter: (cellContent, row) => (
        <Link to={`/all-applications?job_title=${row?.id}&filterValue=true`}>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cellContent) }}></div>
        </Link>
      ),
    },
    {
      dataField: "min_count",
      text: t(`Dashboard.Applications Less than Budget`),
      classes: "Shortlisted-fto-f blue-color text-center",
      headerClasses: "text-center Shortlisted-fto-fs ",
      formatter: (cellContent, row) => {
        const percentage =
          row.total_count > 0 ? (row.min_count / row.total_count) * 100 : 0;
        return `${cellContent} (${percentage}%)`;
      },
    },
    {
      dataField: "in_between_count",
      text: t(`Dashboard.Applications Within Budget`),
      classes: "selected-number text-center",
      headerClasses: "text-center Shortlisted-fto-fs ",
      formatter: (cellContent, row) => {
        const percentage =
          row.total_count > 0
            ? (row.in_between_count / row.total_count) * 100
            : 0;
        return `${cellContent} (${percentage}%)`;
      },
    },
    {
      dataField: "max_count",
      text: t(`Dashboard.Applications More than Budget`),
      classes: "on-board text-center",
      headerClasses: "text-center Shortlisted-fto-fs",
      formatter: (cellContent, row) => {
        const percentage =
          row.total_count > 0 ? (row.max_count / row.total_count) * 100 : 0;
        return `${cellContent} (${percentage}%)`;
      },
    },
    {
      dataField: "total_count",
      text: t(`Dashboard.Total Candidates`),
      classes: "Shortlisted-fto-f Shortlisted-fto-fs  total-amount text-center",
      headerClasses: "text-center Shortlisted-fto-fs",
    },
  ];

  const columnsMargin = [
    {
      dataField: "title_with_salary",
      text: t(`Dashboard.Job Title`),
      classes: "job-title text-left",
      headerClasses: "text-left",
      formatter: cellContent => (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cellContent) }} />
      ),
    },
    {
      dataField: "min_ctc_offered",
      text: t(`Dashboard.Minimum Salary Offered`),
      classes: "Shortlisted-fto-f text-center",
      headerClasses: "text-center",
      // formatter: (cellContent, row) => {
      //   const maxSalary = row.max_salary;
      //   const minMargin = ((maxSalary - row.min_ctc_offered) / maxSalary) * 100;
      //   return parseInt(minMargin);
      // },
    },
    {
      dataField: "max_ctc_offered",
      text: t(`Dashboard.Maximum Salary Offered`),
      classes: "selected-number text-center",
      headerClasses: "text-center",
      // formatter: (cellContent, row) => {
      //   const maxSalary = row.max_salary;
      //   const maxMargin = ((maxSalary - row.max_ctc_offered) / maxSalary) * 100;
      //   return parseInt(maxMargin);
      // },
    },
    {
      dataField: "avg_ctc_offered",
      text: t(`Dashboard.Average Salary Offered`),
      classes: "on-board text-center",
      headerClasses: "text-center",
      // formatter: (cellContent, row) => {
      //   const maxSalary = row.max_salary;
      //   const avgMargin = ((maxSalary - row.avg_ctc_offered) / maxSalary) * 100;
      //   return parseInt(avgMargin);
      // },
    },
    {
      dataField: "total_count",
      text: t(`Dashboard.Total Candidates`),
      classes: "Shortlisted-fto-f  total-amont  text-center",
      headerClasses: "text-center total-candidatesp",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Dashboard.Showing rows`, { from, to, size })}
    </span>
  );
  const options2 = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    totalSize: data.length,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  //tablewrapperref
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="vacancy-tabel timetohires  vacancytables">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="eligible-content">
              <h3 className="d-flex align-items-center gap-2 heading-one">
                {/* Margin and Average Range Difference Percentage */}
                {/* Onboarding Budget Tracker */}
                {t(`Dashboard.Employee Acquisition Cost`)}
              </h3>

              <div className="vacancy-table-row d-flex gap-2">
                <div className="notibtn mt-0 d-flex align-items-center gap-2">
                  <span className="notilab mr-2">
                    {t(`Dashboard.Salary Wise`)}
                  </span>
                  <label className="switch" htmlFor="tableSwitch">
                    <span className="sr-only">Toggle table switch</span>
                    <input
                      type="checkbox"
                      id="tableSwitch"
                      onClick={event => {
                        event.persist();
                        setTableSwitch(event.target.checked);
                      }}
                      defaultChecked={tableSwitch || false}
                    />
                    <div className="slider round"></div>
                  </label>
                  {/* <span className="notilab ml-2">Chart</span> */}
                </div>

                <div className="tale-text right-panel rangetable m-0">
                  <button
                    className="button left"
                    onClick={() => handleScroll("left")}
                    data-tooltip="Scroll Left"
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                  <button
                    className="button right"
                    onClick={() => handleScroll("right")}
                    data-tooltip="Scroll Right"
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="timeto-hire-card userlist">
              <div className="tabel-application tabel-application-auto table-responsive pb-3  center-content-s">
                {tableSwitch ? (
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      {data?.length > 0 && (
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <BootstrapTable
                            keyField="id"
                            data={preprocessedData}
                            columns={columnsMargin}
                            pagination={paginationFactory(options2)}
                            rowClasses={rowClasses}
                          />
                        </div>
                      )}

                      {data?.length === 0 && (
                        // <p className="text-center">No Data Available.</p>
                        <div className="no-data data-available">
                          <img
                            src="../img/data-not-available.png"
                            alt="data not availble"
                          />
                          <h3>{t(`Dashboard.No Item Found`)}</h3>
                          <p>
                            <Trans>{t(`Dashboard.No Item Msg`)}</Trans>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      {data?.length > 0 && (
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <BootstrapTable
                            keyField="id"
                            data={preprocessedData}
                            columns={columns}
                            pagination={paginationFactory(options2)}
                            rowClasses={rowClasses}
                          />
                        </div>
                      )}

                      {data?.length === 0 && (
                        // <p className="text-center">No Data Available.</p>
                        <div className="no-data data-available">
                          <img
                            src="../img/data-not-available.png"
                            alt="data not availble"
                          />
                          <h3>{t(`Dashboard.No Item Found`)}</h3>
                          <p>
                            <Trans>{t(`Dashboard.No Item Msg`)}</Trans>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RangeTableComponent;
